function getVariantTitle() {
    const productJsonScript = document.querySelector('script.product-json');

    // Check if the script exists on the page
    if (productJsonScript) {
        // Parse the JSON data
        const productData = JSON.parse(productJsonScript.textContent);
    
        // Function to get variant title by ID
        function getVariantTitleById(variantId) {
            const variant = productData.variants.find(v => v.id === Number(variantId));
            return variant ? variant.title : null; // Return title or null if not found
        }

        // Get the value of the input element
        const variantInput = document.querySelector('input.formVariantId');
        if (variantInput) {
            const variantId = variantInput.value; // Get the value (string)

            // Use the function to get the variant title
            const variantTitle = getVariantTitleById(variantId);

            if (variantTitle) {
                return `${variantTitle}`;
            } else {
                return variantId;
            }
        } else {
            return "Unknown";
        }

    } else {
        return "Unknown";
    }
    return "Unknown";
}

function getBespokeProductUrl(productName) {
    //const form = document.querySelector('form');
    //const form = document.querySelector('#product-form-installment');
    const form = document.querySelector('#product-form-template--23753820504328__main');
    if(!form)
    {
        console.log("Form not found");
        return;
    }

    // Trigger the check for required fields
    if (!form.reportValidity()) {
        console.log("Some required fields are not filled out or invalid.");
        return;
    }

    // Select the parent element
    //const parentElement = document.querySelector('form');
    //const parentElement = document.getElementById('product-form-installment');
    const parentElement = document.getElementById('product-form-template--23753820504328__main');

    // Get all input fields that are descendants of the parent element
    const inputFields = parentElement.querySelectorAll('input');

    // Get all select fields that are descendants of the parent element
    const selectFields = parentElement.querySelectorAll('select');

    // Initialize an object to store key-value pairs
    const queryParams = {};

    // Process input fields
    inputFields.forEach(input => {
        // Extract the key from the name attribute by removing the `prd_properties[]` wrapper
        let key = input.name || input.id;
        console.log("Input Field: " +key);

        // If the key contains square brackets, extract the text inside
        const bracketMatch = key.match(/\[([^\]]+)\]/);
        if (bracketMatch) {
            key = bracketMatch[1]; // Get the value inside the brackets
        }
        console.log("Filtered Key: " +key);

        // Check if the input is a radio button
        if (input.type === 'radio' && !input.checked) {
            return; // Skip if it's a radio button and not checked
        }

        // Get the value of the input field
        const value = input.value;
        console.log("Value: " +value);

        // Add the key-value pair to the queryParams object
        if (key && key !== 'form_type' && key !== 'utf8' && key !== 'product-id' && key !== 'section-id') {
            queryParams[encodeURIComponent("prd_" + key)] = encodeURIComponent(value);
            console.log("Encoded value: " +encodeURIComponent(value))
        }
    });

    // Process select fields
    selectFields.forEach(selectElement => {
        // Ensure the select element has a 'name' attribute
        if (selectElement.name) {
            const match = selectElement.name.match(/\[(.*?)\]/);
            if (match) {
                // Get the "Fabric" key
                const key = match[1];
    
                // Get the value of the selected option
                const selectedValue = selectElement.value;
    
                // Log the results
                queryParams[encodeURIComponent("prd_" + key)] = encodeURIComponent(selectedValue);
            }
        }
    });

    queryParams["product"] = encodeURIComponent(productName);
    queryParams["variant"] = encodeURIComponent(getVariantTitle());

    // Convert the queryParams object into a URL query string
    const queryString = new URLSearchParams(queryParams).toString();

    // Build the final URL (assuming a base URL)
    const baseURL = '/pages/contact';
    const finalURL = `${baseURL}?${queryString}`;

    window.location.href = finalURL;
}

$(document).ready(function() {
  function canScrollAtLeast100Pixels() {
    const scrollableHeight = $(document).height() - $(window).height();
    return scrollableHeight >= 100;
  }

  /*var toSigil = true;
  var $logo = $('#logo_image'); 
  if ($logo.attr('nosigil') === 'true') {
    toSigil = false;
  }*/
 var toSigil = false;

  function updateStylesOnScroll(scrollValue) {
      const logoLink = document.querySelector('.header-logo-link-scroll');
    if (scrollValue > 100 || !canScrollAtLeast100Pixels()) {
        // User has scrolled down
        if(logoLink) {
            if(scrollValue > 100 || toSigil)
                logoLink.classList.add('is-scrolled');
        }

        $("theme-header .cart--container, theme-header .mobile-menu__trigger, theme-header nav")
            .css("visibility", "visible");
    } else {
        // User has scrolled back up
        if(logoLink)
            logoLink.classList.remove('is-scrolled');

        /*$("theme-header .cart--container, theme-header .mobile-menu__trigger, theme-header nav")
            .css("visibility", "hidden");*/
    }
  }

  if (window.themeSettings && window.themeSettings.showHeaderOnLoad) {
      $("theme-header .cart--container, theme-header .mobile-menu__trigger, theme-header nav")
          .css("visibility", "visible");
  }

  // Initialize visibility based on scrollbar presence
  updateStylesOnScroll(0);
  $(window).scroll(function() {
      const scrollValue = $(this).scrollTop();
      updateStylesOnScroll(scrollValue);
  });
});
